// extracted by mini-css-extract-plugin
export default {"root":"MainList-root_B_ay7","icon":"MainList-icon_r5JMz"};